import React, { Suspense } from 'react';
import { render } from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AnimatedPageLoader } from 'smartsuite-ui';
import { toastContainerProps } from './utils/toastUtils';
import ErrorBoundary from './components/ErrorBoundary';

import 'smartsuite-ui/dist/smartsuite-ui.css';
import 'react-toastify/dist/ReactToastify.css';
import './styles/react-toastify-overrides.css';

import './i18n';

const RecommendedFlightsApp = React.lazy(() =>
    import('./apps/RecommendedFlights/App')
);
const DefaultRoute = React.lazy(() => import('./components/DefaultRoute'));
const WelcomePage = React.lazy(() => import('./components/WelcomePage'));

const rootElement = document.getElementById('root');

const queryClient = new QueryClient({
    defaultOptions: { queries: { refetchOnWindowFocus: false } },
});

render(
    <ErrorBoundary>
        <Suspense fallback={<AnimatedPageLoader />}>
            <Router basename={window.rootUrl}>
                <Switch>
                    <QueryClientProvider client={queryClient}>
                        <Route
                            path="/apps/recommendedFlights"
                            component={RecommendedFlightsApp}
                        />
                        <Route path="/apps/welcome" component={WelcomePage} />
                        <Route exact={true} path="/" component={DefaultRoute} />
                    </QueryClientProvider>
                </Switch>
            </Router>
            <ToastContainer {...toastContainerProps} />
        </Suspense>
    </ErrorBoundary>,
    rootElement
);
